<template lang="html">
	<div class="ad-features clearfix">
		<div class="row">
			<div class="col-4 col-md-12 col-xl-3 img-box">
				<img :src="product.logo" alt="" class="f-l logo" />
			</div>
			<div class="col-8 col-md-12 col-xl-9">
				<div class="p-desc-box f-l">
					<div class="p-name">{{ product.name }}</div>
					<div class="insurance">{{ product.underwritter }}</div>

					<div class="categories clearfix">
						<div
							class="category clearfix"
							v-for="category in product.features"
						>
							<div class="icon f-l">
								<div class="fa fa-check"></div>
							</div>
							<div class="name f-l">{{ category }}</div>
						</div>
					</div>
					<div class="price-box">
						<div class="last f-l strikethrough">
							{{ product.currency
							}}{{ utils.numberWithCommas(product.last_price) }}
						</div>
						<div class="price tx-blue f-l">
							{{ product.currency
							}}{{ utils.numberWithCommas(product.price)
							}}<span class="point">.00</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		product: {
			default: function () {
				return {
					logo: '/img/logos/madison.png',
					name: 'Ndae Freshi',
					underwritter: 'Sanlam Insurance',
					features: ['Theft Protection', 'Collision Damage Waiver'],
					currency: '$',
					price: 34000,
					last_price: 59000,
					rating: 4,
				};
			},
		},
	},
	data() {
		return {
			utils,
		};
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.ad-features {
	background: var(--white);
	box-shadow: 0 10px 23px 0 #45495b19;
	padding: 20px 10px;
	border-radius: 4px;

	.img-box {
		display: flex;
		justify-content: center;
		width: 100%;
		height: 100%;
		padding: 10px 0 0 0;

		.logo {
			width: auto;
			height: auto;
			max-width: 90%;
			max-height: 100%;
		}
	}
	.p-desc-box {
		.p-name {
			font-size: 17px;
			color: var(--text-color);
			font-family: var(--font-bold);
			line-height: 15px;
		}
		.insurance {
			font-size: 13px;
			color: var(--text-grey);
		}
		.categories {
			margin: 5px 0;
			font-size: 14px;
			color: @grey;

			.name {
				font-weight: 600;
			}
			.icon {
				margin: 1px 10px 0 0;
			}
		}
		.price-box {
			margin: 8px 0;

			.price {
				font-size: 26px;
				font-family: var(--font-bold);

				.point {
					font-size: 11px;
				}
			}
			.last {
				margin: 1px 10px 0 0;
				font-weight: 600;
				color: @grey;
				font-size: 14px;
			}
		}
	}
}
</style>
